<template>
  <!-- 表格主体部分 -->
  <tbody class="table-tbody">
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  name: "TbodyEx",
  updated() {
    this.initRow();
  },
  mounted() {
    this.initRow();
  },
  methods: {
    onKey(key, el) {
      let index = el.parentElement.cellIndex;
      if (key == "ArrowDown") {
        let nextEl = el.parentElement.parentElement.nextElementSibling;
        if (nextEl) nextEl.children[index].children[0].focus();
      }
      if (key == "ArrowUp") {
        let previousEl = el.parentElement.parentElement.previousElementSibling;
        if (previousEl) previousEl.children[index].children[0].focus();
      }
    },
    initRow() {
      if (this.$slots.default) {
        let rows = this.$slots.default.filter(f => f.tag);
        rows.forEach(item => {
          item.child.$on("key", this.onKey);
        });
      }
    }
  }
};
</script>


<style lang="stylus" scoped>
.table-tbody
  tr
    text-align center
    height 40px
    line-height 40px
    // border: 1px solid #ddd;
    background-color #fff
  td
    border 1px solid #e0e0e0
    color: red;
</style>
